import { Box, Portal } from '@chakra-ui/react';
import { useFocus } from 'modules/Editor/components/Focus';

interface ResponsiveWidgetToolbarProps {
  children: React.ReactNode;
  isActive: boolean;
}

// Renders the selected responsive widget members toolbar
export const ResponsiveWidgetToolbar = ({ children, isActive }: ResponsiveWidgetToolbarProps) => {
  const { widgetToolbarPortalRef } = useFocus();
  if (!isActive) return null;

  return (
    <Portal containerRef={widgetToolbarPortalRef as React.RefObject<HTMLElement | null> | undefined}>
      <Box zIndex='toolbar'>{children}</Box>
    </Portal>
  );
};
